import { z } from 'zod';

import { regex_iso_date } from '../../../../utils/regex.utils';
import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#ratenkredit-gesch%C3%A4ftskredit-und-sonstige-verbindlichkeit

	{
		"abloesen": true | false,
		"bic": String,
		"datumErsteZahlung": "YYYY-MM-DD",
		"datumLetzteRate": "YYYY-MM-DD",
		"glaeubiger": String,
		"gehoertZuAntragsteller": Antragstellerzuordnung,
		"iban": String,
		"kreditinstitut": String,
		"rateMonatlich": schemaBigDecimal,
		"restschuld": schemaBigDecimal,
		"schlussrate": schemaBigDecimal,
		"urspruenglicherKreditbetrag": schemaBigDecimal,
	}

*/
export const schemaEuropaceRatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit = z.object({
    abloesen: z.optional(z.boolean()),
    bic: z.optional(z.string()),
    datumErsteZahlung: z.optional(z.string().regex(regex_iso_date)),
    datumLetzteRate: z.optional(z.string().regex(regex_iso_date)),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    glaeubiger: z.optional(z.string()),
    iban: z.optional(z.string()),
    id: z.string().min(1),
    kreditinstitut: z.optional(z.string()),
    rateMonatlich: z.optional(schemaBigDecimal),
    restschuld: z.optional(schemaBigDecimal),
    schlussrate: z.optional(schemaBigDecimal),
    urspruenglicherKreditbetrag: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceRatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit = z.infer<
    typeof schemaEuropaceRatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit
>;
